{
  "title": "Control Flames",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "Transmutation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "S",
  "duration": "Instantaneous or 1 hour",
  "description": [
    "You choose nonmagical flame that you can see within range and that fits within a 5-foot cube. You affect it in one of the following ways:",
    "You instantaneously expand the flame 5 feet in one direction, provided that wood or other fuel is present in the new location.",
    "You instantaneously extinguish the flames within the cube.",
    "You double or halve the area of bright light and dim light cast by the flame, change its color, or both. The change lasts for 1 hour.",
    "You cause simple shapes—such as the vague form of a creature, an inanimate object, or a location—to appear within the flames and animate as you like. The shapes last for 1 hour.",
    "If you cast this spell multiple times, you can have up to three of its non-instantaneous effects active at a time, and you can dismiss such an effect as an action."
  ],
  "spellLists": ["druid", "eldritch-knight", "arcane-trickster", "sorcerer", "wizard"]
}
